import { render, staticRenderFns } from "./HighlightButton.vue?vue&type=template&id=9088bf60&"
import script from "./HighlightButton.vue?vue&type=script&lang=js&"
export * from "./HighlightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VContainer,VItem,VItemGroup,VScrollYTransition})
